import urls from '~/urls';

export default {
  encode: `${urls.api}/piracy-secrets/encode`,
  decode: `${urls.api}/piracy-secrets/decode`,

  // External
  kindredYouTube: 'https://www.youtube.com/@kindreon',
};
